<template>
	<li>
		<router-link v-if="nav.path && !nav.blank" :to="nav.path">{{ nav.name }}</router-link>
		<a :href="nav.path" target="_blank" v-else-if="nav.blank">{{ nav.name }}</a>
		<span v-else class="dropdown ">{{ nav.name }}</span>

		<ul v-if="nav.child && nav.child.length > 0">
			<header-nav-link :key="'h-nav-sub'+index" :nav="sub" v-for="(sub, index) in nav.child"/>


		</ul>

	</li>
</template>
<script>
	import NavLink from '@/components/layout/header-nav-link';

	export default {
		name: 'header-nav-link',
		props: ['nav'],
		components:{
			'header-nav-link': NavLink
		}
	}
</script>